import { Navigate, Outlet, useLocation } from 'react-router';

import routes from '../config/routes';
import DefaultLayout from './layout/DefaultLayout';

export default function ProtectedRoute({
  isAllowed,
  redirectPath = routes.login.path,
}) {
  const location = useLocation();

  return isAllowed ? (
    <DefaultLayout>
      <Outlet />
    </DefaultLayout>
  ) : (
    <Navigate to={redirectPath} replace state={{ from: location }} />
  );
}
